import { render, staticRenderFns } from "./DescriptionsSection.vue?vue&type=template&id=c4c0c9ec&scoped=true"
import script from "./DescriptionsSection.vue?vue&type=script&lang=js"
export * from "./DescriptionsSection.vue?vue&type=script&lang=js"
import style0 from "./DescriptionsSection.vue?vue&type=style&index=0&id=c4c0c9ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c0c9ec",
  null
  
)

export default component.exports